import styled from "@emotion/styled";
import { Ruler } from "./elements/Ruler";
import { forwardRef } from "react";

interface PercentageSliderProps {
  value: number;
  setValue: React.Dispatch<React.SetStateAction<number>> | ((value: number) => void);
  isLocked?: boolean;
  minValue?: number;
  maxValue?: number;
  color: string;
}

export const PercentageSlider = forwardRef<
  HTMLDivElement,
  PercentageSliderProps & React.HTMLAttributes<HTMLDivElement>
>(({ value, setValue, isLocked = false, minValue, maxValue, color, ...props }, ref) => {
  return (
    <Container ref={ref} {...props}>
      <FadeOverlay />
      <Ruler
        value={value}
        setValue={setValue}
        color={color}
        minValue={minValue}
        maxValue={maxValue}
        isLocked={isLocked}
      />
    </Container>
  );
});

// Sub-components

const Container = styled.div(() => {
  return {
    position: "relative",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };
});

const FadeOverlay = styled.div(() => {
  return {
    position: "absolute",
    width: "100%",
    height: "100%",
    maxHeight: "50px",
    zIndex: 1,
    pointerEvents: "none",
    background:
      "linear-gradient(90deg, rgba(10,23,23,1) 0%, rgba(10,23,23,0) 20%, rgba(10,23,23,0) 80%, rgba(10,23,23,1) 100%)",
  };
});
